import React, { useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { BiSortAlt2 } from 'react-icons/bi'

function Sortby(props) {
    
    useEffect(() => {
   //      console.log("sorting", props.sortProps)
    }, [props]);

    return (
         <div>
            <small>Sort By</small>
            <BiSortAlt2 size={30} style={{ cursor: "pointer", color: "#2596BE" }} />
        </div>
    );
}

export default Sortby;